<script lang="ts">
	interface Props {
		strokeColor?: string;
	}

	let { strokeColor = "black" }: Props = $props();
</script>

<svg width="54" height="74" viewBox="0 0 54 74" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_623_59)">
		<path
			d="M8.25 17V17C4.79822 17 2 19.7982 2 23.25V64C2 68.4183 5.58172 72 10 72H44C48.4183 72 52 68.4183 52 64V44.5V30.75V23.25C52 19.7982 49.2018 17 45.75 17V17"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
		/>
		<line
			x1="13"
			y1="43"
			x2="41"
			y2="43"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
			stroke-linecap="round"
		/>
		<line
			x1="13"
			y1="51"
			x2="41"
			y2="51"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
			stroke-linecap="round"
		/>
		<line
			x1="13"
			y1="59"
			x2="41"
			y2="59"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
			stroke-linecap="round"
		/>
		<path
			d="M45 18V26H9V18C9 14.6863 11.6863 12 15 12H27H39C42.3137 12 45 14.6863 45 18Z"
			stroke={strokeColor}
			class="svg-stroke"
			stroke-width="4"
		/>
		<circle cx="27" cy="7" r="5" stroke={strokeColor} class="svg-stroke" stroke-width="4" />
	</g>
	<defs>
		<clipPath id="clip0_623_59">
			<rect width="54" height="74" fill="white" />
		</clipPath>
	</defs>
</svg>

<style>
</style>
